import { createColorArray } from '../../utils/colors';
import { displayPercent, displayShortDate } from '../../utils/Format/Format';

export const assetAllocationUtil = (gqlResult) => {
    if (!gqlResult) return null;
    const { assetAllocationGroupedRankings, netAssets } = gqlResult.mutualFund;
    const totalNetAssets = netAssets;
    const someAssetAllocationsNegative = assetAllocationGroupedRankings.some(
        ({ percentTotalNetAssets }) => percentTotalNetAssets < 0
    );

    const filtered = assetAllocationGroupedRankings
        .filter(
            (ele) =>
                ele.percentTotalNetAssets >= 0.005 ||
                ele.percentTotalNetAssets <= -0.005
        )
        .sort((a, b) => b.percentTotalNetAssets - a.percentTotalNetAssets);

    const asOfDate = displayShortDate(filtered[0].asOfDate);

    const colors = createColorArray(filtered.length);

    const data = filtered.map((ele, i) => ({
        label: ele.name,
        value: ele.percentTotalNetAssets,
        color: colors[i]
    }));

    const legendData = data.map((ele) => ({
        ...ele,
        value: displayPercent(ele.value)
    }));

    return {
        data,
        legendData,
        asOfDate,
        totalNetAssets,
        someAssetAllocationsNegative
    };
};
